<div class="flex justify-content-between pt-4 pb-3">
  <div class="flex">
      <span class="p-float-label">
        <input
          [(ngModel)]="deviceFilters.serialNumber"
          (keyup.enter)="applyFilters()"
          type="text"
          id="serialNumber"
          pInputText
        >
        <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
      </span>
    <span class="p-float-label ml-2">
      <input
        [(ngModel)]="deviceFilters.description"
        (keyup.enter)="applyFilters()"
        type="text"
        id="description"
        pInputText
      >
      <label for="description">{{'attribute.description' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2 w-16rem" *ngIf="categories">
      <p-multiSelect
        [(ngModel)]="deviceFilters.categoryNames"
        [options]="categories"
        [filter]="true"
        styleClass="w-full"
        optionLabel="value"
        optionValue="value"
        inputId="category"
        display="chip"
        appendTo="body"
      ></p-multiSelect>
      <label>{{'model.deviceCategory' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2 w-16rem" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
      <p-multiSelect
        [(ngModel)]="deviceFilters.organizationUuids"
        [options]="organizations"
        [filter]="true"
        styleClass="w-full"
        optionLabel="name"
        optionValue="uuid"
        inputId="organization"
        display="chip"
        appendTo="body"
      ></p-multiSelect>
      <label>{{'model.organization' | transloco}}</label>
    </span>
  </div>
  <div>
    <button
      [label]="'common.search' | transloco"
      (click)="applyFilters()"
      pButton
      icon="pi pi-search"
      iconPos="right"
    ></button>
  </div>
</div>

<p-table
  [(selection)]="deviceSelection"
  [(first)]="first"
  [(rows)]="rows"
  [value]="devices"
  [totalRecords]="totalDevices"
  [paginator]="true"
  [autoLayout]="true"
  [sortField]="deviceFilters.sortField"
  [sortOrder]="deviceFilters.sortOrder"
  [lazy]="true"
  (onLazyLoad)="onDevicePageChange($event)"
  (selectionChange)="deviceSelectionChange.emit(deviceSelection)"
  responsiveLayout="stack"
  styleClass="p-datatable-striped"
  dataKey="uuid"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="w-3rem">
        <button
          *ngIf="selectionMode === 'multiple'"
          [class.p-button-danger]="totalDevices > 100"
          [pTooltip]="'error.tooMany.devicesSelectAll' | transloco: { elements: totalDevices }"
          [tooltipDisabled]="totalDevices <= 100"
          (click)="totalDevices <= 100 ? displaySelectAllDialog() : ''"
          pButton
          pRipple
          icon="pi pi-check-square"
          class="p-button-icon-only p-button-text p-0 w-auto p-button-lg"
        ></button>
      </th>
      <th pSortableColumn="serialNumber">
        {{'attribute.serialNumber' | transloco}}
        <p-sortIcon field="serialNumber"></p-sortIcon>
      </th>
      <th pSortableColumn="creationAt">
        {{'attribute.creationAt' | transloco}}
        <p-sortIcon field="creationAt"></p-sortIcon>
      </th>
      <th pSortableColumn="description">
        {{'attribute.description' | transloco}}
        <p-sortIcon field="description"></p-sortIcon>
      </th>
      <th pSortableColumn="deviceCategory.name">
        {{'model.deviceCategory' | transloco}}
        <p-sortIcon field="deviceCategory.name"></p-sortIcon>
      </th>
      <th pSortableColumn="organization.name" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
        {{'model.organization' | transloco}}
        <p-sortIcon field="organization.name"></p-sortIcon>
      </th>
      <th pSortableColumn="dateLastValueReported">
        {{'attribute.dateLastValueReported' | transloco}}
        <p-sortIcon field="dateLastValueReported"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-device>
    <ng-component *ngIf="loadingDevices then skeletonRow else dataRow"></ng-component>
    <ng-template #dataRow>
      <tr>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'common.select' | transloco}}</span>
          <p-tableRadioButton *ngIf="selectionMode === 'single'" [value]="device"></p-tableRadioButton>
          <p-tableCheckbox *ngIf="selectionMode === 'multiple'" [value]="device"></p-tableCheckbox>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
          <a [href]="'/devices/' + device.uuid + '/details'" target="_blank">{{device.serialNumber}}</a>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'attribute.creationAt' | transloco}}</span>
          <p class="text-right md:text-left">{{device.creationAt | customDate}}</p>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
          <p class="text-right md:text-left">{{device.description}}</p>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'model.deviceCategory' | transloco}}</span>
          <p class="text-right md:text-left">{{device.deviceCategory ? device.deviceCategory.name : ''}}</p>
        </td>
        <td class="h-3rem py-0" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
          <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
          <p class="text-right md:text-left">{{device.organization ? device.organization.name : ''}}</p>
        </td>
        <td class="h-3rem py-0">
          <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
          <p class="text-right md:text-left">{{device.dateLastValueReported | customDate}}</p>
        </td>
      </tr>
    </ng-template>
    <ng-template #skeletonRow>
      <tr>
        <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        <td class="h-3rem py-0" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
          <p-skeleton height="1em"></p-skeleton>
        </td>
      </tr>
    </ng-template>
  </ng-template>
</p-table>

